import Node from "src/types/node"

export default class extends Node {}